import React from "react";
import Dropzone from 'react-dropzone';
import { Button } from 'primereact/button';
import { Messages } from 'primereact/messages';
import servicioHttp from "../servicio/ServicioHttp";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Growl } from 'primereact/growl';
import { obtenerContenidoArchivo } from '../servicio/ServicioCodificacionArchivos';
import {AlertaFechaMovimientos} from '../componentes/enviomovimientos/AlertaFechaMovimientos';
import {formatoNombreArchivo }from '../servicio/ServicioCodificacionArchivos';
import servicioObjetos from "../servicio/ServicioObjetos";
export class MovimientosMasivos extends React.Component {
  constructor() {
    super();
    this.state = {
      mostrarModalErrores: false,      
      archivos: [],
      ttCfdi: {},
      errores: [],
      listaTXT: [],
      listaMovimientos: [],
      mostrarModalConfirmacion:false,
      movimientosResumen:[]
    };
    this.guardar = this.guardar.bind(this);
    this.guardarMovimientos = this.guardarMovimientos.bind(this);
    this.cerrarEnvioModal = this.cerrarEnvioModal.bind(this);
    this.setDatos = this.setDatos.bind(this);
  }
  onDrop = (files) => {
    let { archivos } = this.state;

    for (var i = 0; i < files.length; i++) {     
       obtenerContenidoArchivo(files[i]).then(response => {        
          archivos.push(response);
          this.setState({ archivos });
        }).catch(error => {
          console.log(error);
        });
    }
  };
  
  guardarMovimientos() {
    this.setState({ mostrarModalConfirmacion: false });
    const { listaTXT } = this.state;
    servicioHttp.consumirPostHttp("/movimientos/crear_movimientos.json", listaTXT).then((response) => {
      if (response.data.objeto.errores.length > 0) {
        for (let i = 0; i < response.data.objeto.errores.length; i++) {
          let valor = response.data.objeto.errores[i];
          this.messages.show({ severity: 'error', summary: 'Error', detail: valor, sticky: true });
        }
      }

      if (response.data.objeto.exitos.length > 0) {
        for (let i = 0; i < response.data.objeto.exitos.length; i++) {
          let valor = response.data.objeto.exitos[i];
          this.messages.show({ severity: 'success', summary: 'Éxito', detail: valor, sticky: true });

        }
      }
      this.setState({ listaTXT: [] });
      this.setState({ archivos: [] });
    }).catch((error) => {

    });

  }
  mostrarConfirmacion = () => {
    const { listaTXT } = this.state;
    // let movimientosResumen = [];
    // for (let i = 0; i < listaTXT.length; i++) {
    //   let elemento = listaTXT[i];
    //   movimientosResumen = movimientosResumen.concat(elemento.datosMovimientos);
    // }
    this.setState({ movimientosResumen: listaTXT });
  }

  guardar() {
    this.messages.clear();
    let { archivos } = this.state;
    let formData = new FormData();
    for (var i = 0; i < archivos.length; i++) {
      var cfdi = archivos[i];
      let nombre=formatoNombreArchivo(cfdi.name);
      formData.append('recibos', cfdi, nombre);
    }
    this.growl.clear();
    servicioHttp.consumirPostHttp("/movimientos/procesar.json", formData).then((response) => {
      let listaResultados = servicioObjetos.esObjetoVacio(response.data.objeto) ? [] : response.data.objeto.archivoTxt;
      this.setState({ listaTXT: listaResultados });
      this.growl.show({ severity: response.data.error ? 'error' : 'success', summary: response.data.error ? 'Error' : 'Exito', detail: response.data.mensaje,life:15000 });
    }).catch((error) => {
      this.growl.show({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error en el servidor, por favor vuelva a intentar.' });
    });
  }

  plantillaErrorNombre(rowData, column) {

    if (column.rowData.observacionNombre != null)
      return <p style={{ color: '#FF334F' }}>{column.rowData.nombre + " " + column.rowData.observacionNombre}</p>

    else
      return <p>{column.rowData.nombre}</p>

  }
  plantillaErrorApellidoPaterno(rowData, column) {
    if (column.rowData.observacionPrimerApellido != null)
      return <p style={{ color: '#FF334F' }}>{column.rowData.primerApellido + " " + column.rowData.observacionPrimerApellido}</p>

    else
      return <p>{column.rowData.primerApellido}</p>
  }
  plantillaErrorApellidoMaterno(rowData, column) {
    if (column.rowData.observacionSegundoApellido != null)
      return <p style={{ color: '#FF334F' }}>{column.rowData.segundoApellido + " " + column.rowData.observacionSegundoApellido}</p>

    else
      return <p >{column.rowData.segundoApellido}</p>
  }

  plantillaErrorRegistroPatronal(rowData, column) {
    if (column.rowData.observacionRegistroPatronal != null)
      return <p>{column.rowData.registroPatronal + " " + column.rowData.observacionRegistroPatronal}</p>

    else
      return <p >{column.rowData.registroPatronal}</p>
  }
  plantillaErrorNumeroSeguroSocial(rowData, column) {
    if (column.rowData.observacionNumeroSeguroSocial != null)
      return <p style={{ color: '#FF334F' }}>{column.rowData.numeroSeguroSocial + " " + column.rowData.observacionNumeroSeguroSocial}</p>

    else
      return <p >{column.rowData.numeroSeguroSocial}</p>
  }
  plantillaErrorDigitoVerificador(rowData, column) {
    if (column.rowData.observacionDigitoVerificador != null)
      return <p style={{ color: '#FF334F' }}>{column.rowData.digitoVerificador + " " + column.rowData.observacionDigitoVerificador}</p>

    else
      return <p >{column.rowData.digitoVerificador}</p>
  }
  plantillaErrorSalarioBase(rowData, column) {
    if (column.rowData.observacionSalarioBase != null)
      return <p style={{ color: '#FF334F' }}>{column.rowData.salarioBase + " " + column.rowData.observacionSalarioBase}</p>

    else
      return <p>{column.rowData.salarioBase}</p>
  }
  plantillaErrorTipoTrabajador(rowData, column) {
    if (column.rowData.observacionTipoTrabajador != null)
      return <p style={{ color: '#FF334F' }}>{column.rowData.tipoTrabajador + " " + column.rowData.observacionTipoTrabajador}</p>

    else
      return <p>{column.rowData.tipoTrabajador}</p>
  }
  plantillaErrorTipoSalario(rowData, column) {
    if (column.rowData.observacionTipoSalario != null)
      return <p style={{ color: '#FF334F' }}>{column.rowData.tipoSalario + " " + column.rowData.observacionTipoSalario}</p>

    else
      return <p>{column.rowData.tipoSalario}</p>
  }
  plantillaErrorSemanaJornadaReducida(rowData, column) {
    if (column.rowData.observacionJornadaReducida != null)
      return <p style={{ color: '#FF334F' }}>{column.rowData.semanaJornadaReducida + " " + column.rowData.observacionJornadaReducida}</p>

    else
      return <p >{column.rowData.semanaJornadaReducida}</p>
  }
  plantillaErrorFechaMovimiento(rowData, column) {
    if (column.rowData.observacionFechaMovimiento != null)
      return <p style={{ color: '#FF334F' }}>{column.rowData.fechaMovimiento + " " + column.rowData.observacionFechaMovimiento}</p>

    else
      return <p >{column.rowData.fechaMovimiento}</p>
  }

  plantillaErrorTipoMovimiento(rowData, column) {
    if (column.rowData.observacionTipoMovimiento != null)
      return <p style={{ color: '#FF334F' }}>{column.rowData.tipoMovimiento + " " + column.rowData.observacionTipoMovimiento}</p>

    else
      return <p >{column.rowData.tipoMovimiento}</p>
  }

  plantillaErrorUltimoDigito(rowData, column) {
    if (column.rowData.observacionUltimiDigito != null)
      return <p style={{ color: '#FF334F' }}>{column.rowData.ultimoDigito + " " + column.rowData.observacionUltimiDigito}</p>

    else
      return <p >{column.rowData.ultimoDigito}</p>
  }
  plantillaErrorCausaBaja(rowData, column) {
    if (column.rowData.observacionCausaBaja != null)
      return <p style={{ color: '#FF334F' }}>{column.rowData.causaBaja + " " + column.rowData.observacionCausaBaja}</p>

    else
      return <p>{column.rowData.causaBaja}</p>
  }
  plantillaErrorUmf(rowData, column) {
    if (column.rowData.observacionUmf != null)
      return <p style={{ color: '#FF334F' }}>{column.rowData.umf + " " + column.rowData.observacionUmf}</p>

    else
      return <p>{column.rowData.umf}</p>
  }

  plantillaErrorNumeroGuia(rowData, column) {
    if (column.rowData.observacionNumeroGuia != null)
      return <p style={{ color: '#FF334F' }}>{column.rowData.numeroGuia + " " + column.rowData.observacionNumeroGuia}</p>

    else
      return <p>{column.rowData.numeroGuia}</p>
  }
  plantillaErrorClaveTrabajador(rowData, column) {
    if (column.rowData.observacionClaveTrabajador != null)
      return <p style={{ color: '#FF334F' }}>{column.rowData.claveTrabajador + " " + column.rowData.observacionClaveTrabajador}</p>

    else
      return <p>{column.rowData.claveTrabajador}</p>
  }
  plantillaErrorCurp(rowData, column) {
    if (column.rowData.observacionCurp != null)
      return <p style={{ color: '#FF334F' }}>{column.rowData.curp + " " + column.rowData.observacionCurp}</p>

    else
      return <p>{column.rowData.curp}</p>
  }
  
  plantillaErrorLinea(rowData, column) {
    if (column.rowData.observacionLinea != null)
      return <p style={{ color: '#FF334F' }}>{column.rowData.observacionLinea}</p>
  }



  plantillaOpciones(rowData, column) {
    if (rowData.error === "FORMATO INVALIDO")
      return (
        <div className="p-grid">
          <div className="p-col-12 p-md-2">
            <Button
              type="button"
              icon="pi-md-remove-red-eye"
              onClick={(e) => this.mostrarDetalle(column.rowData)}
              className="p-button-warning"
              name="detalle"
              tooltip="Observar errores"
            ></Button>



          </div>
        </div>
      );
  }
  plantillaEliminar(rowData, column) {

    return (
      <div className="p-grid">
        <div className="p-col-12 p-md-2">
          <Button
            type="button"
            icon="pi-md-delete"
            onClick={(e) => this.eliminarArchivo(column.rowData)}
            className="p-button-danger"
            name="eliminar"
            tooltip="Eliminar"
          ></Button>



        </div>
      </div>
    );
  }


  plantillaIconoValido(rowData, column) {
    if (column.rowData.observacionRegistroPatronal === null && column.rowData.observacionNumeroSeguroSocial === null && column.rowData.observacionDigitoVerificador === null && column.rowData.observacionPrimerApellido === null && column.rowData.observacionSegundoApellido === null && column.rowData.observacionNombre === null && column.rowData.observacionSalarioBase === null && column.rowData.observacionTipoTrabajador === null && column.rowData.observacionTipoSalario === null && column.rowData.observacionJornadaReducida === null && column.rowData.observacionFechaMovimiento === null && column.rowData.observacionUmf === null && column.rowData.observacionNumeroGuia === null && column.rowData.observacionClaveTrabajador === null && column.rowData.observacionCurp === null && column.rowData.observacionUltimiDigito === null && column.rowData.observacionTipoMovimiento === null && column.rowData.observacionCausaBaja === null)
      return (
        <div className="p-grid">
          <div className="p-col-12 p-md-2">
            <Button
              type="button"
              icon="pi-md-check-circle"
              className="p-button-success"
              name="estatus de linea"
              tooltip="Estatus de linea"
            ></Button>



          </div>
        </div>
      );
    else
      return (
        <div className="p-grid">
          <div className="p-col-12 p-md-2">
            <Button
              type="button"
              icon="pi-md-check-circle pi pi-times"
              className="p-button-danger"
              name="estatus de linea"
              tooltip="Estatus de linea"
            ></Button>
          </div>
        </div>
      );

  }
  formatoArchivo = (rowData, column) => {
    if (rowData.error === "FORMATO INVALIDO")
      return <p style={{ backgroundColor: '#f008', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>FORMATO INVALIDO</p>;
    else
      return <p style={{ backgroundColor: '#33ff4c', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>FORMATO CORRECTO</p>;

  }

  mostrarDetalle(objeto) {

    this.setState({
      listaMovimientos: objeto.datosMovimientos,
      mostrarModalErrores: true,

    });
  }

  eliminarArchivo(objeto) {
    let { listaTXT,archivos } = this.state;
    listaTXT.splice(listaTXT.indexOf(objeto), 1);
    archivos.splice(archivos.indexOf(objeto), 1);


  }


  resetEstados() {
    this.setState({
      mostrarModalErrores: false,

    });
  }

  cerrarEnvioModal() {
    this.setState({
      mostrarModalConfirmacion: false,
      movimientosResumen: []
    });
  }

  setDatos(datos) {
    this.setState({
      listaTXT: datos,
      movimientosResumen: datos
    });
  }

  render() {
    let { listaTXT, listaMovimientos, movimientosResumen } = this.state;
    const archivos = this.state.archivos.length;
    const pieDialogo = (
      <div className="ui-dialog-buttonpane p-clearfix">

        <Button
          label="Salir"
          icon="pi-md-close"
          onClick={this.resetEstados.bind(this)}
          className="p-button-danger "
        />
      </div>
    );
    const dialogFooterConfirmacion = (
      <div>
        <Button
          icon="pi-md-check"
          onClick={this.guardarMovimientos}
          label="Si estoy seguro"
          className="p-button flat-btn"
        />
        <Button
          icon="pi-md-close"
          onClick={this.cerrarEnvioModal}
          label="No estoy seguro"
          className="p-button-danger flat-btn"
        />
      </div>
    );
    return (
      <div className="p-grid">
        <Growl ref={(el) => this.growl = el} />
        <AlertaFechaMovimientos funcionGuardarMovimientos={this.guardarMovimientos} datos={movimientosResumen}
        setDatos={this.setDatos} funcionCerrar={this.cerrarEnvioModal}/>
        <div className="p-col-12">
          <div className="card">
            <div className="card-title">Cargar archivos txt</div>
            <p>Es esta sección usted puede cargar los archivos de los movimientos IMSS</p>
          </div>
        </div>
        <div className="p-col-12">
          <div className="card">
            <Messages ref={(el) => this.messages = el}></Messages>
            <br></br>

            <Dropzone accept=".txt" onDrop={this.onDrop}>
              {({ getRootProps, getInputProps }) => (
                <section >
                  <div  {...getRootProps({ className: 'dropzone rectangulo' })}>
                    <input   {...getInputProps()} />
                    <center><p>Arrastra tus archivos txt o da click aquí</p></center>
                  </div>
                  <br></br>
                  <Button label="Validar Archivos Txt" icon="pi-md-folder" onClick={this.guardar} />
                  {listaTXT.length > 0 ? <Button label="Guardar Archivos Txt" icon="pi-md-save" onClick={this.mostrarConfirmacion} /> : null}
                  <aside>
                    <h4>Cantidad de archivos a procesar</h4>
                    <ul>{archivos}</ul>
                  </aside>

                </section>
              )}
            </Dropzone>
          </div>
        </div>
        <div className="p-col-12">
          <div className="card card-w-title">
            <DataTable
              value={listaTXT}
              editable={true}
              selectionMode="single"
              responsive={true}
              header="Archivos"
              paginator={true}
              rows={20}>
              <Column
                field="nombreArchivo"
                header="Nombre Archivo"
                autoLayout={true}
                width="1000px"
              />
              <Column
                body={this.formatoArchivo.bind(this)}
                header="Estado"
                autoLayout={true}
              />

              <Column
                header="Detalles de error"
                body={this.plantillaOpciones.bind(this)}
                autoLayout={true}
              />
              <Column
                header="Eliminar"
                body={this.plantillaEliminar.bind(this)}
                autoLayout={true}
              />
            </DataTable>
          </div>
        </div>
        <Dialog
          appendTo={document.body} style={{ width: '90%', height: '90%' }}
          visible={this.state.mostrarModalErrores}
          header="Detalle de los movimientos"
          modal={true}
          footer={pieDialogo}
          onHide={this.resetEstados.bind(this)}>
          <div className="p-grid form-group">

            <DataTable
              value={listaMovimientos}
              responsive={true}
              header="Datos del archivo"
              resizableColumns={true}
              paginator={true}
              rows={20}
              autoLayout={true}>

              <Column
                header="Linea"
                field="numeroLinea"
                autoLayout={true} resizableColumns={true}
                style={{ width: '80px' }}
              />
              <Column
                header="Estatus"
                body={this.plantillaIconoValido}
                autoLayout={true} resizableColumns={true}
                style={{ width: '100px' }}
              />
              <Column
                body={this.plantillaErrorRegistroPatronal.bind(this)}
                header="Registro Patronal"
                autoLayout={true} resizableColumns={true}
                style={{ width: '200px' }}
              />
              <Column
                body={this.plantillaErrorNumeroSeguroSocial.bind(this)}
                header="Número seguro social"
                autoLayout={true} resizableColumns={true}
                style={{ width: '200px' }}
              />
              <Column
                body={this.plantillaErrorDigitoVerificador.bind(this)}
                header="Dígito Verificador"
                autoLayout={true} resizableColumns={true}
                style={{ width: '150px' }}
              />
              <Column
                body={this.plantillaErrorApellidoPaterno.bind(this)}
                header="Primer Apellido"
                autoLayout={true} resizableColumns={true}
                style={{ width: '200px' }}
              />
              <Column
                body={this.plantillaErrorApellidoMaterno.bind(this)}
                header="Segundo Apellido"
                autoLayout={true} resizableColumns={true}
                style={{ width: '200px' }}
              />
              <Column
                body={this.plantillaErrorNombre.bind(this)}
                header="Nombre"
                autoLayout={true} resizableColumns={true}
                style={{ width: '200px' }}
              />
              <Column
                body={this.plantillaErrorSalarioBase.bind(this)}
                header="Salario Base"
                autoLayout={true} resizableColumns={true}
                style={{ width: '200px' }}
              />
              <Column
                body={this.plantillaErrorTipoTrabajador.bind(this)}
                header="Tipo trabajador"
                autoLayout={true} resizableColumns={true}
                style={{ width: '130px' }}
              />
              <Column
                body={this.plantillaErrorTipoSalario.bind(this)}
                header="Tipo Salario"
                autoLayout={true} resizableColumns={true}
                style={{ width: '130px' }}
              />
              <Column
                body={this.plantillaErrorSemanaJornadaReducida.bind(this)}
                header="Jornada Reducida"
                autoLayout={true} resizableColumns={true}
                style={{ width: '150px' }}
              />
              <Column
                body={this.plantillaErrorFechaMovimiento.bind(this)}
                header="Fecha Movimiento"
                autoLayout={true} resizableColumns={true}
                style={{ width: '250px' }}
              />
              <Column
                body={this.plantillaErrorUmf.bind(this)}
                header="UMF"
                autoLayout={true} resizableColumns={true}
                style={{ width: '100px' }}
              />
              <Column
                body={this.plantillaErrorNumeroGuia.bind(this)}
                header="Numero Guia"
                autoLayout={true} resizableColumns={true}
                style={{ width: '150px' }}
              />
              <Column
                body={this.plantillaErrorClaveTrabajador.bind(this)}
                header="Clave Trabajador"
                autoLayout={true} resizableColumns={true}
                style={{ width: '200px' }}
              />
              <Column
                body={this.plantillaErrorCurp.bind(this)}
                header="CURP"
                autoLayout={true} resizableColumns={true}
                style={{ width: '250px' }}
              />
              <Column
                body={this.plantillaErrorCausaBaja.bind(this)}
                header="Causa Baja"
                autoLayout={true} resizableColumns={true}
                style={{ width: '250px' }}
              />
               <Column
                body={this.plantillaErrorTipoMovimiento.bind(this)}
                header="Tipo Movimiento"
                autoLayout={true} resizableColumns={true}
                style={{ width: '250px' }}
              />
              <Column
                body={this.plantillaErrorLinea.bind(this)}
                header="Formato"
                autoLayout={true} resizableColumns={true}
                style={{ width: '250px' }}
              />
               <Column
                body={this.plantillaErrorUltimoDigito.bind(this)}
                header="Identificador del formato"
                autoLayout={true} resizableColumns={true}
                style={{ width: '250px' }}
              />
            </DataTable>
          </div>
        </Dialog>
        <Dialog
        appendTo={document.body}
        header="Confirmación"
        visible={this.state.mostrarModalConfirmacion}
        modal={true}
        style={{ width: "30vw" }}
        footer={dialogFooterConfirmacion}
        onHide={() =>
        this.setState({
        mostrarModalConfirmacion: false,
        })
        }>
      <h2>¿Estás seguro que deseas enviar los movimientos?</h2>
      </Dialog>
      </div>

    );
  }
}